import styled from 'styled-components'

import Link from '../../../../../global/Link'

export const Title = styled.h3`
  margin-bottom: 20px;
`

export const VisitDispensaryLink = styled(Link)`
  align-self: end;
  background: ${({ theme }) => theme.colors.brand.blue};
  border: 1px solid ${({ theme }) => theme.colors.brand.blue};
  border-radius: 15px;
  color: ${({ theme }) => theme.colors.brand.white};
  cursor: pointer;
  display: block;
  margin: 20px 0 0 auto;
  padding: 15px 10px;
  transition: 0.3s;
  text-decoration: none;
  text-transform: uppercase;
  width: fit-content;

  &:hover {
    background: ${({ theme }) => theme.colors.brand.white};
    border: 1px solid ${({ theme }) => theme.colors.brand.blue};
    color: ${({ theme }) => theme.colors.brand.blue};
  }
`

export const FinishOnboardingLink = styled(Link)`
  color: ${({ theme }) => theme.colors.component.link};
`
